export default __webpack_public_path__ + "static/josiah shoemaker-330b2c486a9fbb8b70d3a31eb9133abb.png";